export const PDP_CONTAINER_WIDTH = 360;
